import React from 'react';

import ShowLessonsModel from '../../functionalpagelogin/learningPath/WShowLessonsModel';
import courseConfigs from '../../../config/courseConfigs';

const FinancialCourse = () => {
  return (
    <ShowLessonsModel
      courseConfig={courseConfigs.financiara}
    />
  );
};

export default FinancialCourse;